<div class="page">
  <div class="header">
    <h1 class="header-title">
      <mat-icon>perm_contact_calendar</mat-icon>
      <span>Rooster</span>
    </h1>
  </div>

  <mat-card class="content">
    <div class="card-grid">
      @if (hasOwnSchedule()) {
        <mat-card
          class="landing-card"
          (click)="goToOwnSchedule()"
          (keydown.enter)="goToOwnSchedule()"
          (keydown.space)="$event.preventDefault(); goToOwnSchedule()"
          tabindex="0"
          role="button"
        >
          <div class="card-visual">
            <mat-icon>person</mat-icon>
          </div>
          <div class="card-label">Mijn rooster</div>
        </mat-card>
      }

      @if (canViewEmployeeList()) {
        <mat-card
          class="landing-card"
          (click)="goToEmployeeList()"
          (keydown.enter)="goToEmployeeList()"
          (keydown.space)="$event.preventDefault(); goToEmployeeList()"
          tabindex="0"
          role="button"
        >
          <div class="card-visual">
            <mat-icon>person_search</mat-icon>
          </div>
          <div class="card-label">Rooster medewerkers</div>
        </mat-card>
      }

      @if (canViewAvailability()) {
        <mat-card
          class="landing-card"
          (click)="goToAvailability()"
          (keydown.enter)="goToAvailability()"
          (keydown.space)="$event.preventDefault(); goToAvailability()"
          tabindex="0"
          role="button"
        >
          <div class="card-visual">
            <mat-icon>event_available</mat-icon>
          </div>
          <div class="card-label">Personeelsbeschikbaarheid</div>
        </mat-card>
      }
    </div>
  </mat-card>
</div>
